export default __webpack_public_path__ + "static/media/gg2.0d802721.jpg";